import { IonCard, IonCardSubtitle } from "@ionic/react";
import Page from "../components/Page";
import photo1 from "../resources/photo1.jpeg";
const Home: React.FC = () => {
  return (
    <Page title="Nicki's Wishlist">
     
    </Page>
  );
};

export default Home;

const Table = () => {
  return (
    <table style={{ width: "100%" }} className="table table-striped">
      {" "}
      <tbody>
        {" "}
        <tr>
          {" "}
          <th>Model</th> <td  className="pl-4">Nicki Woods</td>{" "}
        </tr>{" "}
        <tr>
          {" "}
          <th>Age </th> <td className="pl-4">27</td>{" "}
        </tr>{" "}
        <tr>
          {" "}
          <th>Height </th> <td className="pl-4">5'5 ft</td>{" "}
        </tr>{" "}
        <tr>
          {" "}
          <th>Weight </th> <td className="pl-4">135 lbs</td>{" "}
        </tr>{" "}
        {/* <tr>
          {" "}
          <th>Measurements </th> <td className="pl-4">88 - 62 - 89 cm // US 34 - 24 - 35</td>{" "}
        </tr>{" "} */}
        {/* <tr>
          {" "}
          <th>Dress size </th> <td className="pl-4">34-36// US 4-6</td>{" "}
        </tr>{" "} */}
        <tr>
          {" "}
          <th>Cup size </th> <td className="pl-4">36D</td>{" "}
        </tr>{" "}
        <tr>
          {" "}
          <th>Eye color </th> <td className="pl-4">Brown</td>{" "}
        </tr>{" "}
        <tr>
          {" "}
          <th>Hair color </th> <td className="pl-4">Black</td>{" "}
        </tr>{" "}
        <tr>
          {" "}
          <th>Hair length </th> <td className="pl-4">Long</td>{" "}
        </tr>{" "}
        <tr>
          {" "}
          <th>Build </th> <td className="pl-4">All natural, beautiful face</td>{" "}
        </tr>{" "}
        {/* <tr>
          {" "}
          <th>Tattoo </th> <td className="pl-4">Yes</td>{" "}
        </tr>{" "} */}
        {/* <tr>
          {" "}
          <th>Professional background </th> <td className="pl-4">Escort</td>{" "}
        </tr>{" "} */}
        <tr>
          {" "}
          <th>Languages </th> <td className="pl-4">Spanish ( fluent ), English ( fluent )</td>{" "}
        </tr>{" "}
        <tr>
          {" "}
          <th>Nationality </th> <td className="pl-4">Cuban</td>{" "}
        </tr>{" "}
        {/* <tr>
          {" "}
          <th>Cuisine </th> <td className="pl-4">French, mediterranean, japanese</td>{" "}
        </tr>{" "} */}
        {/* <tr>
          {" "}
          <th>Drinks </th> <td className="pl-4">Gin Tonic, Champagner, Wine</td>{" "}
        </tr>{" "} */}
        {/* <tr>
          {" "}
          <th>Clothing style </th> <td className="pl-4">Casual, elegant</td>{" "}
        </tr>{" "} */}
        <tr>
          {" "}
          <th>Perfume </th> <td className="pl-4">Chanel</td>{" "}
        </tr>{" "}
        {/* <tr>
          {" "}
          <th>Gift ideas </th>{" "}
          <td className="pl-4">
            I love to explore and experience new things! Whether at a dinner, a
            jet ski ride or later in the hotel ;) - I get the most enjoyment
            from simply having fun together! Let's spend moments together that
            we will never forget!
          </td>{" "}
        </tr>{" "} */}
        <tr>
          {" "}
          <th>Character </th>{" "}
          <td className="pl-4">Communicative, educated, uncomplicated, positive</td>{" "}
        </tr>{" "}
        {/* <tr>
          {" "}
          <th>Interests </th> <td className="pl-4">Travel, profound Conversations, eat good</td>{" "}
        </tr>{" "} */}
        {/* <tr>
          {" "}
          <th>Travel availability </th> <td className="pl-4">Worldwide</td>{" "}
        </tr>{" "} */}
        {/* <tr>
          {" "}
          <th>Duo partner </th> <td className="pl-4">No</td>{" "}
        </tr>{" "}
        <tr>
          {" "}
          <th>Couples </th> <td className="pl-4">No</td>{" "}
        </tr>{" "} */}
      </tbody>{" "}
    </table>
  );
};
